<template>
  <div>
    <v-autocomplete
      v-model="select"
      :items="items"
      item-text="longName"
      return-object
      attach="#search-menu-location"
      :search-input.sync="search"
      no-filter
      outlined
      :full-width="true"
      auto-select-first
      color="primary"
      :label="$t('searchBar.label')"
      clearable
      hide-details
      :allow-overflow="false"
      ref="autocomplete"
      :no-data-text="
        items.length == 0 && search == null
          ? $t('searchBar.pleaseSearch')
          : $t('searchBar.noResults')
      "
      append-icon="fas fa-compass"
      background-color="white"
    >
      <template v-slot:append-item>
        <v-divider></v-divider>
        <div class="mt-2">
          <v-card
            v-if="navigatorLocation.error"
            color="red lighten-5"
            elevation="0"
            class="pa-2 text-caption mx-2"
          >
            <span class="red--text">
              {{ $t("searchBar.unableToGetYourLocation") }}
            </span>
          </v-card>
          <v-list-item
            dense
            @click="
              /myPosition/.test(placeType) ? 0 : searchNavigatorLocation()
            "
          >
            <v-list-item-icon
              ><v-icon color="primary">gps_fixed</v-icon></v-list-item-icon
            >
            <v-list-item-title>
              {{ $t("searchBar.aroundMe") }}
            </v-list-item-title>
          </v-list-item>
        </div>
      </template>
    </v-autocomplete>
    <div id="search-menu-location" class="relative"></div>
  </div>
</template>

<script>
import SearchService from "../../search/services/SearchService";
import SearchLocationAutocompleteItem from "../classes/SearchLocationAutocompleteItem";
export default {
  name: "SearchLocationAutocomplete",

  props: {
    locationData: Object,
    placeType: {
      type: String,
      required: true,
      default: "country",
    },
  },

  data() {
    return {
      items: [],
      search: null,
      select: new SearchLocationAutocompleteItem(),
      navigatorLocation: {
        active: false,
        error: false,
        loading: false,
        object: {},
        shortName: "Ma position",
      },
      autocompleteWidth: 0,
    };
  },
  methods: {
    updateSearchLocationAutocompleteItems(search) {
      this.items = SearchService.updateSearchLocationAutocompleteItems(search);
    },
    updateDestinationAutocomplete(value) {
      this.$emit("updateDestinationAutocomplete", value);
    },
    askNavigatorLocation() {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          (response) => resolve(response),
          (error) => reject(error)
        );
      });
    },
    searchNavigatorLocation() {
      this.navigatorLocation.error = false;
      this.askNavigatorLocation()
        .then((response) => {
          this.navigatorLocation.active = true;
          this.navigatorLocation.object = response;
          this.$refs.autocomplete.blur();
          this.$emit("updateNavigatorPosition", this.navigatorLocation.object);
        })
        .catch(() => (this.navigatorLocation.error = true));
    },
    searchNavigatorLocationAround(kilometers) {
      this.navigatorLocation.error = false;
      this.askNavigatorLocation()
        .then((response) => {
          this.navigatorLocation.active = true;
          this.navigatorLocation.object = response;
          this.$refs.autocomplete.blur();
          this.$emit("searchXkmAroundMe", {
            position: this.navigatorLocation.object,
            kilometers,
          });
        })
        .catch(() => (this.navigatorLocation.error = true));
    },
  },
  watch: {
    /* Watch search to refresh Items from Mapbox geocoding */
    search(val) {
      if (val !== null && val !== undefined && val != "") {
        if (val !== this.select.longName) {
          this.updateSearchLocationAutocompleteItems(val);
        }
      }
    },
    /* Watch select: 
      - when an item is picked ==> event: updateDestinationAutocomplete to TheSearch 
      - when select is undefined (autocomplete clear by user) ==> event: updateDestinationAutocomplete 
      - when select is update with locationData, no event sent to The Search
      */
    select(select) {
      if (select !== undefined) {
        select.shortName != this.locationData.shortName
          ? this.updateDestinationAutocomplete(select)
          : false;
      } else {
        this.select = new SearchLocationAutocompleteItem();
        this.items = [];
      }
    },
    locationData(location) {
      if (location.shortName !== this.select.shortName) {
        if (location.shortName == "") {
          this.items = [];
          this.search = null;
          this.select = new SearchLocationAutocompleteItem();
        } else {
          this.items = [location];
          this.select = location;
          this.search = location.longName;
        }
      }
    },
  },
};
</script>

<style scoped></style>
